import React from 'react';
import BotHistoryContainer from '../../../Container/Dor/BotHistory';

const BotHistory = () => {
  return (
    <BotHistoryContainer />
  );
};

export default BotHistory; 